import { AspectContainer } from '../../AspectContainer';
import { BuildingViewerRoomData } from '../../../../Content';
import { PickableRegion } from './PickableRegion';

export interface Props {
  src: string;
  rooms: BuildingViewerRoomData[];
  activeRoom: BuildingViewerRoomData | null;
  onRoomClick: (room: BuildingViewerRoomData) => void;
}

export const UnitPicker: React.FC<Props> = (props) => {
  return (
    <AspectContainer aspect={0.5625}>
      <div
        style={{
          height: '100%',
          backgroundImage: `url("${props.src}")`,
          backgroundSize: 'cover',
          position: 'relative',
        }}
      >
        {/* Unit Region */}
        {props.rooms.map((room) => (
          <PickableRegion
            key={room.id}
            region={room.region}
            isActive={room === props.activeRoom}
            onClick={() => props.onRoomClick(room)}
          />
        ))}
      </div>
    </AspectContainer>
  );
};
